import React from 'react';
import PropTypes from 'prop-types';
import Tag from 'components/Tag';
import { JOB_STATES, BADGE_COLOR_STATES } from 'utils/constants/jobDetails';
import { useTranslation } from 'react-i18next';

const StatusTag = ({ status }) => {
  const { t } = useTranslation('Jobs');
  if (!BADGE_COLOR_STATES[status]) return null;
  return (
    <Tag
      text={t(JOB_STATES[status])}
      skin={BADGE_COLOR_STATES[status]}
      data-testid="status-tag"
    />
  );
};

StatusTag.propTypes = {
  status: PropTypes.string
};

export default StatusTag;
